export default __webpack_public_path__ + "static/mimino-ea5a52acd2cdd9c8ae6570011e20bd09.webp";